import { Component, OnInit } from '@angular/core'; //PARA SER UM COMPONENTE TEM QUE TER ESSE IMPORT
import { Router } from "@angular/router";

import { Task } from "../../tasks/shared/task.model";
import { TaskService } from "../../tasks/shared/task.service";

import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Observable";

@Component({
    selector: 'task-search',
    //templat: `<p></p>`
    templateUrl: './task-search.component.html'
})

/** CLASSE DO COMPONENT */
export class TaskSearchComponent implements OnInit{

    public searchTerms: Subject<string> = new Subject();
    public tasks: Task[] = [];

    public constructor(private taskService: TaskService, private router: Router){

    }

    /**
     * ngonInit
     */
    public ngOnInit() {
        this.searchTerms
        .debounceTime(500) //ESPERA 1/2 SEG PARA PODER FAZER A BUSCA
        .distinctUntilChanged() //Ñ FAZ A BUSCA SE A PALAVRA QUE DIGITOU FOR IGUAL A ULTIMA DO ULTIMO TERM
        .switchMap(
            //SE O CAMPO DE BUSCA Ñ ESTIVER VAZIO ELE CHAMA O MÉTODO
                //SE ESTIVE VAZIO CHAMA UM ARRAY DE TAREFAS VAZIO
            term => term ? this.taskService.searchByTitle(term) : Observable.of<Task[]>([])
        ).subscribe(
            tasks => {
                this.tasks = tasks;
                console.log("Pesquisa: "+ tasks)
            },
            () => {
                //alert("Tarefa não existe!");
                this.ngOnInit();
                console.clear();
            })
    }

    /**
     * search
     * MÉTODO RESPONSÁVEL POR BUSCAR TAREFA
     */
    public search(term: string) {
        this.searchTerms.next(term);
    }

    /**
     * goToTask
     */
    public goToTask(task: Task) {
        this.tasks = [];
        this.router.navigate(['/tasks', task.id]);
    }
}


// WEBPACK FOOTER //
// C:/xampp2/htdocs/angular-front/src/app/navbar/task-search/task-search.component.ts